/**
 * デバウンス関数
 * @param {Function} func - 実行する関数
 * @param {number} delay - 遅延時間（ミリ秒）
 * @returns {Function} デバウンスされた関数
 */
export const debounce = (func, delay) => {
  let timeoutId;

  return function (...args) {
    const context = this;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
};

/**
 * フォント読み込み専用デバウンス
 * @param {Function} fontLoader - フォント読み込み関数
 * @param {number} delay - 遅延時間（デフォルト: 300ms）
 * @returns {Function} デバウンスされたフォント読み込み関数
 */
export const debounceFontLoad = (fontLoader, delay = 300) => {
  return debounce(fontLoader, delay);
};
